import { TFunction } from 'src/constants/i18next';
import { TSelectItem } from '../components/types';

/**
 * Maps the timeframes to a select item
 *
 * @param {string[]} timeframes
 * @param {TFunction} t
 * @return {*}  {TSelectItem[]}
 */
export const mapTimeframes = (
    timeframes: string[],
    t: TFunction
): TSelectItem[] =>
    timeframes.map((timeframe) => ({
        value: timeframe,
        label: t(timeframe),
    }));
